// Formats sans dépendance d'interface : heure de Paris pour les visites, durées et taux.

const PARIS = "Europe/Paris";
const parisLong = new Intl.DateTimeFormat("fr-FR", { timeZone: PARIS, weekday: "long", day: "numeric", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit" });
const parisShort = new Intl.DateTimeFormat("fr-FR", { timeZone: PARIS, weekday: "short", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
const parisParts = new Intl.DateTimeFormat("en-GB", { timeZone: PARIS, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23" });

export function parisDateTime(iso: string | null | undefined, short = false): string {
  if (!iso) return "—";
  return (short ? parisShort : parisLong).format(new Date(iso));
}

function parisOffsetMs(utcMs: number): number {
  const p = Object.fromEntries(parisParts.formatToParts(new Date(utcMs)).map((x) => [x.type, x.value]));
  const asUtc = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
  return asUtc - utcMs;
}

/** Convertit une saisie « 2026-10-03T18:00 » (heure de Paris) en instant ISO. */
export function parisLocalToIso(local: string): string | null {
  const m = local.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/);
  if (!m) return null;
  const guess = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]);
  const first = guess - parisOffsetMs(guess);
  const second = guess - parisOffsetMs(first);
  return new Date(second).toISOString();
}

/** Durée lisible à partir d'un nombre d'heures. */
export function hoursLabel(h: number | null | undefined): string {
  if (h === null || h === undefined) return "—";
  if (h < 48) return `${h} h`;
  const d = Math.round(h / 24);
  return `${d} jour${d > 1 ? "s" : ""}`;
}

export function bpLabel(bp: number | null | undefined): string {
  if (bp === null || bp === undefined) return "—";
  return `${Math.round(bp / 100)} %`;
}

